// extracted by css-extract-rspack-plugin
export default {"cls1":"OffsiteAuthorCard-cls1_bOc","cls2":"OffsiteAuthorCard-cls2_0Ol OffsiteAuthorCard-cls1_bOc"};